import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import DashboardLayout from "./components/DashboardLayout";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import Accounts from "./pages/Accounts";
import Transactions from "./pages/Transactions";
import Clients from "./pages/Clients";
import ClientTransactions from "./pages/ClientTransactions";
import Companies from "./pages/Companies";
import CompanySalary from "./pages/CompanySalary";
import InvestmentPlatforms from "./pages/InvestmentPlatforms";
import PlatformInvestments from "./pages/PlatformInvestments";
import "./App.css";

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            {/* Public routes */}
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />

            {/* Protected routes */}
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <DashboardLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Navigate to="/dashboard" replace />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="transactions" element={<Transactions />} />
              <Route path="accounts" element={<Accounts />} />
              <Route path="clients" element={<Clients />} />
              <Route
                path="clients/:clientId/transactions"
                element={<ClientTransactions />}
              />
              <Route
                path="clients/:clientId/add-transaction"
                element={<ClientTransactions />}
              />
              <Route path="companies" element={<Companies />} />
              <Route
                path="companies/:companyId/salary"
                element={<CompanySalary />}
              />
              <Route path="investments/platforms" element={<InvestmentPlatforms />} />
              <Route
                path="investments/platform/:platformId"
                element={<PlatformInvestments />}
              />
            </Route>

            {/* Catch all route */}
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
